'use client'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { createContext, useContext, useRef, useState } from 'react'
import { useMountEffect } from '@/hooks/useMountEffect'
import copy from '../_content/site-copy.json'
const entryWords = copy.site.wordmark.join(' ').split(' ')
const EntryContext = createContext<(() => void) | null>(null)
export function MuseumTransition({ children }: { children: React.ReactNode }) {
  const router = useRouter()
  const [active, setActive] = useState(false)
  const busy = useRef(false)
  const timers = useRef<ReturnType<typeof setTimeout>[]>([])
  useMountEffect(() => () => timers.current.forEach(clearTimeout))
  const enter = () => {
    if (busy.current) return
    busy.current = true
    setActive(true)
    timers.current.push(setTimeout(() => router.push('/museum/exhibits'), 300))
    timers.current.push(
      setTimeout(() => {
        busy.current = false
        setActive(false)
        requestAnimationFrame(() =>
          document
            .querySelector<HTMLElement>('.museum-room h1')
            ?.focus({ preventScroll: true }),
        )
      }, 5400),
    )
  }
  return (
    <EntryContext value={enter}>
      <div inert={active}>{children}</div>
      {active && (
        <div className="museum-transition" aria-hidden="true">
          <div className="museum-transition-wordmark">
            <span className="museum-entry-mark">
              {entryWords.map((word) => (
                <span key={word}>{word}</span>
              ))}
            </span>
          </div>
        </div>
      )}
    </EntryContext>
  )
}
export function EnterLink() {
  const enter = useContext(EntryContext)
  return (
    <Link
      className="museum-enter"
      href="/museum/exhibits"
      onNavigate={(event) => {
        if (enter) {
          event.preventDefault()
          enter()
        }
      }}
    >
      {copy.enter}
      <span aria-hidden="true">↵</span>
    </Link>
  )
}
